interface LocationMessageProps {
  text: string;
  url: string;
  latitude: number | null;
  longitude: number | null;
}
//AIzaSyChmMDXGATRvXLcXDcoWywvxWfzbyyWXlw
const LocationMessage = ({ text, url, latitude, longitude }: LocationMessageProps) => {
  // Link para o Google Maps
  const mapUrl1 = `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=15&size=600x300&markers=color:red|${latitude},${longitude}&key=AIzaSyChmMDXGATRvXLcXDcoWywvxWfzbyyWXlw`;



  const mapsUrl =
    latitude && longitude
      ? `https://www.google.com/maps?q=${latitude},${longitude}`
      : "#";

  // Preview estático opcional (sem KEY)
  const staticMap =
    latitude && longitude
      ? `https://maps.googleapis.com/maps/api/staticmap?center=${latitude},${longitude}&zoom=16&size=300x200&markers=${latitude},${longitude}&key=AIzaSyChmMDXGATRvXLcXDcoWywvxWfzbyyWXlw`
      : null;

  return (
    <div className="location-message p-2 border rounded bg-light">
      {/* Titulo e descrição */}
      <div className="mb-2"
        style={{
          display: "-webkit-box",
          WebkitLineClamp: 2,
          WebkitBoxOrient: "vertical",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "pre-line",
        }}

      >
        {text}
      </div>


      {/* Mapa */}
      {staticMap && (
        <img
          src={staticMap}
          alt="map preview"
          className="img-fluid rounded mb-2"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",  // ⬅️ impede corte
          }}
        />
      )}

      {/* Botões */}
      <div className="d-flex gap-2">
        <a href={mapsUrl} target="_blank" rel="noreferrer" className="btn btn-sm btn-primary">
          Abrir no Maps
        </a>

        {url && (
          <a href={url} target="_blank" rel="noreferrer" className="btn btn-sm btn-outline-secondary">
            Site
          </a>
        )}
      </div>
    </div>
  );
};

export default LocationMessage;
